import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Step } from '../../shared/models/steps.model';
import { ResourceMediaLite } from '../../shared/models/generic/media/resource-media-lite.model';

export class RecipeValidators {
  static stepsUseAppliance: ValidatorFn = (control: AbstractControl<Step[]>) => {
    const steps = control.value;

    if (!Array.isArray(steps) || steps.length === 0) {
      return null;
    }

    const hasAtLeasOnStepUsingAppliance = steps.find((step) => !!step.useAppliance) !== undefined;
    if (!hasAtLeasOnStepUsingAppliance) {
      return {
        atLeastOneStepMustUseAppliance: true,
      };
    }
    return null;
  };

  public static resourceMediaIsValid: ValidatorFn = (
    control: AbstractControl<ResourceMediaLite | null | undefined>
  ): ValidationErrors | null => {
    const resourceMedia = control.value;
    if (resourceMedia?.hasOwnProperty('media')) {
      return {
        mediaInvalid: true,
      };
    }
    return null;
  };

  public static durationsAreValid: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (control.value < 1) {
      return {
        invalidDuration: true,
      };
    }
    return null;
  };
}
